import { isSSR } from '@/utils/index.js'

export default {
  namespaced: true,
  state () {
    return {
      hostname: isSSR() ? null : window.location.origin,
      baseApiUrl: null,
      locale: 'en', // default locale,
      leftNavOpened: isSSR() ? false : window.innerWidth > 990,
      leftNavActivated: true,
      viewport: {
        width: isSSR() ? null : window?.innerWidth,
        height: isSSR() ? null : window?.innerHeight
      },
      httpStatus: 200
    }
  },
  mutations: {
    SET_HOSTNAME (state, val) {
      state.hostname = val
    },
    SET_BASE_API_URL (state, val) {
      state.baseApiUrl = val
    },
    SET_LOCALE (state, val) {
      state.locale = val
    },
    SET_LEFT_NAV_OPENED (state, val) {
      state.leftNavOpened = val
    },
    SET_LEFT_NAV_ACTIVATED (state, val) {
      state.leftNavActivated = val
    },
    SET_VIEWPORT (state, val) {
      state.viewport = val
    },
    SET_HTTP_STATUS (state, val) {
      state.httpStatus = val
    }
  },
  actions: {
    updateHostname ({ commit }, val) {
      commit('SET_HOSTNAME', val)
    },
    updateBaseApiUrl ({ commit }, val) {
      commit('SET_BASE_API_URL', val)
    },
    updateLocale ({ commit }, val) {
      commit('SET_LOCALE', val)
    },
    updateLeftNavOpened ({ commit }, val) {
      commit('SET_LEFT_NAV_OPENED', val)
    },
    updateLeftNavActivated ({ commit }, val) {
      commit('SET_LEFT_NAV_ACTIVATED', val)
    },
    updateViewport ({ commit }, val) {
      commit('SET_VIEWPORT', val)
    },
    updateHttpStatus ({ commit }, val) {
      commit('SET_HTTP_STATUS', val)
    },
    updateViewportFromWindow ({ commit, dispatch, getters }, updateLeftNav = false) {
      commit('SET_VIEWPORT', {
        width: window.innerWidth,
        height: window.innerHeight
      })
      if (updateLeftNav) {
        dispatch('updateLeftNavOpened', !getters.shouldCloseLeftNav)
      }
    }
  },
  getters: {
    hostname: state => state.hostname,
    baseApiUrl: state => state.baseApiUrl,
    locale: state => state.locale,
    leftNavOpened: state => state.leftNavOpened,
    leftNavActivated: state => state.leftNavActivated,
    viewport: state => state.viewport,
    viewportWidth: state => state.viewport.width,
    isSmallMobile: state => state.viewport.width && state.viewport.width < 480,
    isMobile: state => state.viewport.width && state.viewport.width < 600,
    isTablet: state => state.viewport.width && state.viewport.width >= 600 && state.viewport.width < 1024,
    isDesktop: state => state.viewport.width && state.viewport.width >= 1024,
    shouldCloseLeftNav: state => state.viewport.width && state.viewport.width < 990,
    mainScrollableContainer: (state, getters) => getters.shouldCloseLeftNav ? window : document.getElementById('l-generalContainer')
  }
}
